export default "__VITE_ASSET__DUreiwT7__"